import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';

export const TRACKING_PROMO_BANNER_SCHEMA = Object.freeze({
  IDENTIFIER: '',
});
const RECORD = generateSchema(TRACKING_PROMO_BANNER_SCHEMA);
const KEYS: any = generateKeys(TRACKING_PROMO_BANNER_SCHEMA);

export class PromoBannerTrackingObject
  extends Record(RECORD)
  implements ITrackingObject {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingObjectNamesEnum.promo_banner;
  }

  get properties() {
    return this.toJS();
  }
}
